import {
  normalizePersonCategories,
  type MeSession,
} from "@/lib/types";

const ADMIN_PASSWORD_KEY = "bcec_admin_password";
const LEGACY_ADMIN_KEY = "bcec_admin_api_key";
const ME_SESSION = "bcec_me_session";

export function getAdminPassword(): string | null {
  if (typeof window === "undefined") return null;
  const password = localStorage.getItem(ADMIN_PASSWORD_KEY);
  if (password) return password;
  // Clear legacy API key storage — coordinators now use password auth
  if (localStorage.getItem(LEGACY_ADMIN_KEY)) {
    localStorage.removeItem(LEGACY_ADMIN_KEY);
  }
  return null;
}

export function setAdminPassword(password: string) {
  localStorage.setItem(ADMIN_PASSWORD_KEY, password);
  localStorage.removeItem(LEGACY_ADMIN_KEY);
}

export function clearAdminPassword() {
  localStorage.removeItem(ADMIN_PASSWORD_KEY);
  localStorage.removeItem(LEGACY_ADMIN_KEY);
}

/** @deprecated Use getAdminPassword */
export function getAdminApiKey(): string | null {
  return getAdminPassword();
}

/** @deprecated Use setAdminPassword */
export function setAdminApiKey(key: string) {
  setAdminPassword(key);
}

/** @deprecated Use clearAdminPassword */
export function clearAdminApiKey() {
  clearAdminPassword();
}

export function getMeSession(): MeSession | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(ME_SESSION);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as MeSession;
    return {
      ...parsed,
      person_categories: normalizePersonCategories(parsed.person_categories),
    };
  } catch {
    return null;
  }
}

export function setMeSession(session: MeSession) {
  localStorage.setItem(ME_SESSION, JSON.stringify(session));
}

export function clearMeSession() {
  localStorage.removeItem(ME_SESSION);
}
